"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_router_dom_1 = require("react-router-dom");
//
// components
//
const Profile = (0, react_1.lazy)(() => Promise.resolve().then(() => __importStar(require('./Profile'))));
const Security = (0, react_1.lazy)(() => Promise.resolve().then(() => __importStar(require('./Security'))));
const Communications = (0, react_1.lazy)(() => Promise.resolve().then(() => __importStar(require('./Communications'))));
const LoadingSpinner_1 = __importDefault(require("components/general/LoadingSpinner"));
const StyledMessageContainer_1 = require("components/Dashboard/StyledMessageContainer");
const Layout_1 = require("./Layout");
const Settings = () => (react_1.default.createElement(react_router_dom_1.Routes, null,
    react_1.default.createElement(react_router_dom_1.Route, { element: react_1.default.createElement(Layout_1.Layout, null), path: '*' },
        react_1.default.createElement(react_router_dom_1.Route, { element: react_1.default.createElement(react_1.Suspense, { fallback: react_1.default.createElement(StyledMessageContainer_1.StyledMessageContainer, null,
                    react_1.default.createElement(LoadingSpinner_1.default, null)) },
                react_1.default.createElement(Profile, null)), path: 'profile' }),
        react_1.default.createElement(react_router_dom_1.Route, { element: react_1.default.createElement(react_1.Suspense, { fallback: react_1.default.createElement(StyledMessageContainer_1.StyledMessageContainer, null,
                    react_1.default.createElement(LoadingSpinner_1.default, null)) },
                react_1.default.createElement(Security, null)), path: 'security' }),
        react_1.default.createElement(react_router_dom_1.Route, { element: react_1.default.createElement(react_1.Suspense, { fallback: react_1.default.createElement(StyledMessageContainer_1.StyledMessageContainer, null,
                    react_1.default.createElement(LoadingSpinner_1.default, null)) },
                react_1.default.createElement(Communications, null)), path: 'communications' }),
        react_1.default.createElement(react_router_dom_1.Route, { element: react_1.default.createElement(react_router_dom_1.Navigate, { to: 'profile' }), index: true }))));
exports.default = Settings;
